export default {
    data() {
        return {
            scripts: [],
            styles: []
        }
    },

    created() {
        const siteWrapper = document.querySelector('.js-app')
        this.scripts = [...siteWrapper.querySelectorAll('script')]
        this.styles = [...siteWrapper.querySelectorAll('style')]

        this.scripts.forEach(script => script.remove())
        this.styles.forEach(style => style.remove())
    },

    mounted() {
        this.$nextTick(() => {
            this.scripts.forEach( script => document.head.appendChild(script) )
            this.styles.forEach( style => document.head.appendChild(style) )
        })
    },
}